export default Object.freeze({
    REGULAR_SEGMENT: 1,
    TRANSFER_SEGMENT: 3,
    BREAK_SEGMENT: 4,
});
